import { useEffect } from 'react'
import { useLocation } from 'react-router'

import { useFeatureFlags } from 'features/project/hooks/use-feature-flags'
import mixpanel from 'trackers/mixpanel'

const useMixpanel = (): Record<string, never> => {
  const location = useLocation()
  const { data } = useFeatureFlags()

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    if (searchParams.get('share_type')) {
      mixpanel.register({ shared_session: true })
      mixpanel.track('share_link', {
        url: window.location.href,
        share_type: searchParams.get('share_type'),
        share_user: searchParams.get('share_user'),
      })
    } else if (searchParams.get('utm_source')) {
      mixpanel.register({ shared_session: true })
      mixpanel.track('share_link', {
        url: window.location.href,
        share_type: searchParams.get('utm_source'),
        share_user: searchParams.get('utm_source'),
      })
    } else {
      mixpanel.register({ shared_session: false })
    }
  }, [location.search])

  useEffect(() => {
    if (data) {
      mixpanel.register({
        is_training: !!(data as Record<string, boolean> | undefined)?.[
          'is_training'
        ],
      })
    }
  }, [data])

  return {}
}

export default useMixpanel
